import React, { useEffect, useState } from "react";
import { api_url, titleDescription } from "../../config/Config";
import { Button, Table } from "react-bootstrap";
import _fetch from "../../config/api";
import dateformat from "dateformat";
import { ColorRing } from "react-loader-spinner";
import ReactPaginate from "react-paginate";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";

const SalaryWithdraw = (props: any) => {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.title = `${props.pageTitle} | ${titleDescription}`;
  });

  const [withdrawHistory, setWithdrawHistory] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalWithdraw, setTotalWithdraw] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setpage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [keyCount, setKeycount] = useState(0);

  useEffect(() => {
    getWithdrawHistory();
  }, [page, limit]);

  const getWithdrawHistory = async () => {
    setLoading(true);
    let res = await _fetch(`${api_url}withdraw/salary-withdraw?limit=${limit}&page=${page}`, "GET", {})
    if (res?.status === "success") {
      setLoading(false);
      setWithdrawHistory(res?.data?.data);
      setTotalRecords(res?.total);
      setTotalWithdraw(res?.totalWithdraw);
    }
    if (page > 1) {
      setKeycount(0);
      var count = page - 1;
      setKeycount(count * limit);
    }
  }

  const handlePageClick = async (event: any) => {
    const newOffset = (event.selected + 1);
    setpage(newOffset);
  };

  return (
    <main>
      <div className="uni-level-outer">
        <div className="coustom_container">
          <div className="level_inner loader_main">
            {loading &&
              <div className="spinner_bg">

                <div className="color_ring">  <ColorRing
                  visible={true}
                  height="80"
                  width="80"

                  ariaLabel="blocks-loading"
                  wrapperStyle={{}}
                  wrapperClass="blocks-wrapper"
                  colors={['#2b3892', '#2b3892', '#2b3892', '#2b3892', '#2b3892']}
                /></div>

              </div>
            }
            <div className="top_section_unilevel cash_flow">
              <h4>{t("WITHDRAW SUMMARY")}</h4>
              <p className="text-white">Total Payout: ${totalWithdraw}</p>
            </div>
            <div className="table_section">
              <div className="scrolling_table">
                <div className="scroll_under">
                  <Table className="support_table">
                    <thead>
                      <tr className="table_heading_row">
                        <th className="table_heading">{t("#")}</th>
                        <th className="table_heading">{t("Request No.")}</th>
                        <th className="table_heading">{t("Amount")}</th>
                        <th className="table_heading">{t("Deduction")}</th>
                        <th className="table_heading">{t("Payable Amount")}</th>
                        <th className="table_heading">{t("Type")}</th>
                        <th className="table_heading">{t("Status")}</th>
                        <th className="table_heading">{t("Hash")}</th>
                        <th className="table_heading">{t("Remark")}</th>
                        <th className="table_heading">{t("Request Date")}</th>
                        <th className="table_heading">{t("Paid Date")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {withdrawHistory?.map((item: any, index: any) => {
                        return (
                          <>
                            <tr className="table_data_row">
                              <td className="table_data">
                                <div className="pic_text">{page > 1 ? index + keyCount + 1 : index + 1}</div>
                              </td>
                              <td className="table_data">
                                <div className="pic_text">{item?.request_id}</div>
                              </td>
                              <td className="table_data">
                                <div className="pic_text">${item?.amount?.toFixed(2)}</div>
                              </td>

                              <td className="table_data">${item?.deduction?.toFixed(2)}</td>
                              <td className="table_data payment_fee">${item?.payable_amount?.toFixed(2)}</td>
                              <td className="table_data"> {item?.type.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase())} </td>
                              <td className="table_data">{item?.status === 'Approve' ? <span className="badge bg-success">Approved</span> : item?.status === 'Reject' ? <span className="badge bg-danger">Reject</span> : <span className="badge bg-primary">Pending</span>}  </td>
                              <td className="table_data">{/^\d+$/.test(item?.hash) ? '' : <Link target="blank" to={`https://bscscan.com/tx/${item?.hash}`}>{item?.hash}</Link>}</td>
                              <td className="table_data"> {item?.remark ? item?.remark : ''} </td>
                              <td className="table_data"> {dateformat(item?.created_at, "dd-mm-yyyy hh:MM:ss TT")}</td>
                              <td className="table_data"> {item?.status != 'Pending' ? dateformat(item?.updated_at, "dd-mm-yyyy hh:MM:ss TT") : "-"} </td>
                            </tr >
                          </>
                        )
                      })}
                    </tbody>
                  </Table>
                  {totalRecords > 100 && <ReactPaginate className="pagination__2 " activeClassName="active"
                    breakLabel="..."
                    nextLabel=">"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={1}
                    pageCount={totalRecords / 100}
                    previousLabel="<"
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main >
  )
}

export default SalaryWithdraw;